import { render, staticRenderFns } from "./Served.vue?vue&type=template&id=9ce2d754&scoped=true&"
import script from "./Served.vue?vue&type=script&lang=js&"
export * from "./Served.vue?vue&type=script&lang=js&"
import style0 from "./Served.vue?vue&type=style&index=0&id=9ce2d754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce2d754",
  null
  
)

export default component.exports